import { useMemo } from "react";

export const useColorByCategory = (allColors = [], categoryType = "standard") => {
	return useMemo(() => {
		if (!allColors || allColors.length === 0) return [];
		const type = categoryType.toLowerCase();
		if (type === "standard") {
			return allColors.filter((color) => color?.color_category?.toLowerCase().includes("standard"));
		}
		if (type === "premium") {
			return allColors.filter((color) => !color?.color_category?.toLowerCase().includes("standard"));
		}
		return allColors.filter((color) => color?.color_category?.toLowerCase().includes(type));
	}, [allColors, categoryType]);
};

export const useColorPicker = (allColors = [], selectedSiding = "", applicableType = "") => {
	return useMemo(() => {
		if (!allColors || allColors.length === 0 || !selectedSiding || !applicableType) {
			return {
				all: [],
				standard: [],
				premium: []
			};
		}
		const siding = selectedSiding.toLowerCase();
		const applicable = applicableType.toLowerCase();
		const filteredColors = allColors.filter(
			(color) => color?.color_category_mapping?.material_category?.some((mat) => siding.includes(mat.toLowerCase())) && color?.applicable_on?.some((app) => app.toLowerCase().includes(applicable))
		);
		const standardColors = filteredColors.filter((color) => color?.plan?.toLowerCase().includes("free"));
		const premiumColors = filteredColors.filter((color) => color?.plan?.toLowerCase().includes("paid"));
		return {
			all: filteredColors,
			standard: standardColors,
			premium: premiumColors
		};
	}, [allColors, selectedSiding, applicableType]);
};
export const usePremiumColorDetection = (premiumColors = [], selectedColorValue = "") => {
	return useMemo(() => {
		if (!premiumColors || premiumColors.length === 0 || !selectedColorValue) {
			return false;
		}
		return premiumColors.some((color) => selectedColorValue === color?.hex_value?.replace("#", "0x"));
	}, [premiumColors, selectedColorValue]);
};
